import {
  error,
  money,
  tabaPayError,
} from 'services/graphql/fragments/Fragments';
import { AnalyticsEventFragment } from 'services/graphql/fragments/HomeTilesContentFragment';
import { gql } from 'urql';

const TabaPayChallengeLookup = gql`
  mutation TabaPayChallengeLookup($input: TabaPayChallengeLookupInput!) {
    tabaPayChallengeLookup(input: $input) {
      ... on TabaPayChallengeLookupResultSuccess {
        challengeURL
        dsId
        payload
        processorTransactionId
        transactionID
        __typename
      }

      ... on TabaPayChallengeLookupResultError {
        ...error
        __typename
      }
      ... on TabaPayCustomError {
        ...tabaPayError
        __typename
      }
      ... on TabaPayPartialAuth {
        partialAuthTitle: title
        partialAuthMessage: message
        statusCode
        approvedAmount {
          ...money
        }
        actions {
          buttonText
          buttonStyle
          id
          buttonOnClick {
            __typename
            ... on SDContinueClientFlowAction {
              __typename
              analyticsEvent {
                ...analytics
              }
            }
          }
        }
        displayAnalytics {
          ...AnalyticsEventFragment
        }
        __typename
      }
    }
  }
  ${error}
  ${money}
  ${tabaPayError}
  ${AnalyticsEventFragment}
`;

export default TabaPayChallengeLookup;
